export default function CheckBig() {
    return (<svg id="Group_11935" data-name="Group 11935" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
        <g id="check" transform="translate(0)">
            <path id="Path_20962" data-name="Path 20962" d="M7.951,18.917a.652.652,0,0,1-1.083,0l-4.324-5.57a1.794,1.794,0,0,1,0-2.092l.541-.7a.978.978,0,0,1,1.624,0l2.7,3.477,7.3-9.4a.978.978,0,0,1,1.624,0l.541.7a1.794,1.794,0,0,1,0,2.092Z" transform="translate(-2.208 -4.207)" fill="#93d16b" />
        </g>
    </svg>
    )
}